module.exports = __webpack_public_path__ + "static/macinstallericon-f13ab03d30a92659b777904956298d46.png";